import { memo, useMemo } from 'react';
import classNames from 'classnames';
import TextAreaAutosize from 'react-textarea-autosize';

import { TTextAreaProps } from './text-area.types';

import styles from './text-area.module.css';
import { isDefined } from '@/utils/is-defined';
import Text from '@ui/text/text/text';

const TextArea = memo(
  ({
    borderDesign = 'GlobalIcoText3',
    textDesign = 'GlobalIcoText1',
    placeholderDesign = 'GlobalIcoText3',
    typography = 'P2',
    className,
    borderRadius = '16px',
    padding = '16px',
    style: propsStyle,
    label,
    ...rest
  }: TTextAreaProps) => {
    const classes = useMemo(() => {
      return classNames(styles.textArea, className, {
        [styles[`border-${borderDesign}`]]: borderDesign,
        [styles[`color-${textDesign}`]]: textDesign,
        [styles[`placeholder-${placeholderDesign}`]]: placeholderDesign,
        [typography]: typography,
      });
    }, [className, borderDesign, textDesign, placeholderDesign, typography]);

    const style = useMemo(
      () => ({
        ...propsStyle,
        ...(isDefined(borderRadius) ? { '--text-area-border-radius': borderRadius } : {}),
        ...(isDefined(padding) ? { '--text-area-padding': padding } : {}),
      }),
      [borderRadius, padding, propsStyle]
    );

    return (
      <div className="flex-column gap-4">
        {isDefined(label) && (
          <Text design="GlobalIcoText3" className="L2 margin-l-16">
            {label}
          </Text>
        )}
        <TextAreaAutosize style={style} className={classes} {...rest} />
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;
